//翻倍结算系数
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -65px);">
          <vxe-grid show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                  <vxe-button v-if="basCompanyDoubleSettleCoefficientImport" status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="$refs.doubleSettleCoefficientExcelUpload.show()">导入
                  </vxe-button>
                  <vxe-button v-if="basCompanyDoubleSettleCoefficientExport" status="primary" class="button-sty" icon="el-icon-download"
                              @click="doExcel()">导出
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="6vw" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="有效时间:" field="time">
                  <template v-slot style=" display: inline-block;width:20%!important;">
                    <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    v-model="formData.validTime" clearable/>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="完工方式">
                  <template v-slot>
                    <el-select v-model="formData.finishType" style="width:9vw ;">
                      <el-option label="总部代完工" :value="1"/>
                      <el-option label="网点PC端完工" :value="2"/>
                      <el-option label="网点APP完工" :value="3"/>
                      <el-option label="师傅APP完工" :value="4"/>
                      <el-option label="接口完工" :value="5"/>
                      <el-option label="其他" :value="9"/>
                    </el-select>
                  </template>
                </vxe-form-item>

              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>


    <excel-upload ref="doubleSettleCoefficientExcelUpload" title="翻倍结算系数导入" url="/basic/basCompanyDoubleSettleCoefficient/import"
                  temp-url="/admin/sys-file/local/file/doubleSettleCoefficientInfo.xlsx" @refreshDataList="refreshChange"></excel-upload>
  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import ItemCategorySelect from "@/components/formItem/itemCategorySelect.vue";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {mapGetters} from "vuex";
import ExcelUpload from "./excel";


export default {
  name: 'doubleSettle',

  components: {ItemCategorySelect, ServiceTypeCascader, editView, pager,ExcelUpload},
  data() {
    return {
      basCompanyDoubleSettleCoefficientExport: false,
      basCompanyDoubleSettleCoefficientImport: false,
      doubleSettleCoefficientExcelUpload: false,
      total: 0,
      getListPageUrl: '/basic/basCompanyDoubleSettleCoefficient/getListPage',
      getListByExcel: '/basic/basCompanyDoubleSettleCoefficient/export',
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      dataId2: 0,

      showEdit: false,
      showEdit2: false,

      vxeOption: {},
      // 查询参数
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        validTime:'',
        finishType:null
      },
      formData: {
        validTime:'',
        finishType:null
      },

      pageSizes: [10, 20, 100],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '名称', field: 'name', width: 150,},
        {
          title: '是否启用', field: 'usable', width: 125, slots: {
            default: ({row}) => {
              if (row.usable == 1) {
                return [
                  <div class="txt-status ">
                    <span>是</span>
                  </div>
                ];
              } else if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else {
                return [
                  <div class="txt-status neutral">
                    <span>未知</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '完工方式', field: 'finishType', width: 125, slots: {
            default: ({row}) => {
              if (row.finishType == 1) {
                return [
                  <div class="txt-status ">
                    <span>总部代完工</span>
                  </div>
                ];
              } else if (row.finishType == 2) {
                return [
                  <div class="txt-status disable">
                    <span>网点PC端完工</span>
                  </div>
                ];
              } else if (row.finishType == 3) {
                return [
                  <div class="txt-status disable">
                    <span>网点APP完工</span>
                  </div>
                ];
              }else if (row.finishType == 4) {
                return [
                  <div class="txt-status disable">
                    <span>师傅APP完工</span>
                  </div>
                ];
              }else if (row.finishType == 5) {
                return [
                  <div class="txt-status disable">
                    <span>接口完工</span>
                  </div>
                ];
              }else if (row.finishType == 9) {
                return [
                  <div class="txt-status disable">
                    <span>其他</span>
                  </div>
                ];
              } else {
                return [
                  <div class="txt-status neutral">
                    <span>未知</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '开始时间', field: 'beginDate', width: 110,},
        {title: '结束时间', field: 'endDate', width: 110,},
        {title: '翻倍结算系数', field: 'doubleSettleCoefficient', width: 110,},
        {title: '创建时间', field: 'createTime', width: 150},
        {title: '创建人', field: 'createBy', width: 150,},
        {
          width: 80, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ]
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  created() {
    this.basCompanyDoubleSettleCoefficientExport = this.permissions["basCompanyDoubleSettleCoefficientExport"];
    this.basCompanyDoubleSettleCoefficientImport = this.permissions["basCompanyDoubleSettleCoefficientImport"];
  },
  methods: {
    refreshChange() {
      this.getTableData()
    },
    //导出
    doExcel() {
      this.$mask.open()
      doCheckExcle(fileNames.doubleSettleCoefficient).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(this.getListByExcel, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
		toFilterData() {
      this.searchEvent();
    },


    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        validTime:'',
        finishType:null,
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.validTime = ''
      this.requestParam.finishType = null

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
::v-deep .vxe-grid .vxe-form .vxe-form--item-inner > .align--right {
    text-align: right;
    width: 5vw!important;
}
</style>
